import {remCalc} from '../../_utils'

const controlStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: remCalc(16),
    height: remCalc(16),
    flexShrink: 0,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'border.neutral.highlight',
    borderRadius: '50%',
    bg: 'background.base.default',
    boxShadow: 'inset 0 0 0 1px var(--chakra-colors-border-neutral-highlight)',
    filter: 'drop-shadow(0 0 0 var(--chakra-shadows-neutral-xs)) drop-shadow(0 1px 2px var(--chakra-shadows-neutral-xs))',

    _checked: {
        bg: 'radio.bg.default',
        borderColor: 'border.neutral.highlight',

        _hover: {
            bg: 'radio.bg.hover',
            borderColor: 'border.neutral.highlight',
        },

        _disabled: {
            bg: 'radio.bg.checkedDisabled',
        },
    },

    _hover: {
        bg: 'background.base.elevated',
    },

    _focusVisible: {
        boxShadow:
            'inset 0 0 0 1px var(--chakra-colors-background-base-default), 0 1px 2px 0 var(--chakra-shadows-neutral-xs), 0 0 0 2px var(--chakra-shadows-accent-lg)',
        border: '1px solid var(--chakra-colors-border-neutral-highlight)',
        outline: 'none',
    },

    _disabled: {
        bg: 'background.base.deep',

        _hover: {
            bg: 'background.base.deep',
            cursor: 'not-allowed',
        },
    },
}

export default {
    parts: ['container', 'control', 'dot', 'label'],
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: remCalc(8),
            cursor: 'pointer',
        },
        controlStyle,
        control: {
            ...controlStyle,
            _checked: {
                ...controlStyle._checked,
                _before: {
                    content: '""',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    width: remCalc(6),
                    height: remCalc(6),
                    borderRadius: '50%',
                    bg: 'foreground.neutral.inverse',
                    transform: 'translate(-50%, -50%)',
                },
            },
        },
        dotStyle: {
            width: remCalc(6),
            height: remCalc(6),
            borderRadius: '50%',
            bg: 'foreground.neutral.inverse',
        },
        label: {
            textStyle: 'body-small',
            color: 'text.default',
        },
    },
    variants: {
        checkout: {
            container: {
                marginTop: remCalc(4),
            },
        },
    },
}
